const tooltipMap = {}

function initializeTooltips() {
  const tooltipElements = document.querySelectorAll('[data-tooltip]')
  tooltipElements.forEach((el) => {
    initTooltip(el)
  })
}

function initTooltip(el) {
  const tooltipMessage = el.dataset.tooltip // el.getAttribute('tooltip')

  const tooltip = createTooltip(el, tooltipMessage)
  tooltipMap[el.id] = tooltip

  const onMouseOver = () => {
    showTooltip(el, tooltip)
  }
  const onMouseOut = () => {
    hideTooltip(el, tooltip)
  }
  el.addEventListener('mouseenter', onMouseOver)
  el.addEventListener('mouseleave', onMouseOut)
}

function createTooltip(el, tooltipMessage) {
  const tooltipDiv = document.createElement('div')
  tooltipDiv.id = el.id + '-tooltip'
  tooltipDiv.className = 'md:absolute top-0 left-0 p-2 bg-offblack/70 text-white pointer-events-none z-40 font-goudy text-sm rounded-md'
  tooltipDiv.innerHTML = `<p>${tooltipMessage}</p>`
  tooltipDiv.style.opacity = 0
  tooltipDiv.style.transition = "opacity 400ms ease-in-out"
  tooltipDiv.style.maxWidth = '200px'
  tooltipDiv.style.zIndex = 1000001
  return tooltipDiv
}

function showTooltip(el, tooltip) {
  if (!el || !tooltip) return
  const tooltipMessage = el.dataset.tooltip
  tooltip.innerHTML = `<p>${tooltipMessage}</p>`
  document.body.appendChild(tooltip)
  const pos = el.getBoundingClientRect()
  const tooltipRect = tooltip.getBoundingClientRect()
  tooltip.style.transform = `translate(${pos.x + pos.width / 2 - tooltipRect.width / 2}px, ${pos.y - tooltipRect.height - 4 + window.scrollY}px)`
  tooltip.style.opacity = 1

}

function hideTooltip(el, tooltip) {
  if (!tooltip) return

  tooltip.style.opacity = 0
  tooltip.remove()
}

window.addEventListener('load', (evt) => {
  initializeTooltips()
})